import { Inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import {
  BaseFpxRoGridHelper,
  BaseFpxRoGridHandleAction,
  ToolBar,
  GridTransformFn,
  CriteriaQuery,
} from "@fpx/core";
import { RetailStock } from "src/app/retail-common.service";
import { ProcessShellService } from "src/app/process-shell/services/process-shell.service";
import { PopupComponent } from 'src/app/common/components/popup/popup.component';
import { IPopupScreenData } from 'src/app/common/models/popup-screen-data.model';
import { InfoPopupComponent } from 'src/app/core/components/popup/info-popup/info-popup.component';//import { Unpostedtransactiondtls } from '../unpostedtransactiondtls-service/unpostedtransactiondtls.model';
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { FormGroup } from "@angular/forms";
import { Unpostedtransaction } from "../unpostedtransaction-service/unpostedtransaction.model";

@Injectable()
export class UnpostedTransactiondtlsDisplayGridHelper extends BaseFpxRoGridHelper {
  constructor(
    private _router: Router,
    private _retailCommonService: RetailStock,
    private _processShellService: ProcessShellService,
    private _dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) private data: IPopupScreenData

  ) {
    super();
    this.addHandleActions("onclick", this.unpostedTransactiondtlsDisplayGridView);
    this.addHandleActions("modify", this.unpostedTransactiondtlsDisplayGridModify);
    this.addHandleActions("add", this.unpostedTransactiondtlsDisplayGridEntry);
  }

  public override postFindallInterceptor = (payload: any) => {
    return payload?.map(
      (item) =>
        ({
          ...item,
        })
    );
  };

  initialCriteria =new CriteriaQuery();

  public override doPreInit(): void {
    //   const accountNumber = this.getRoutingParam('accountNumber');
    //   let criteriaQuery = new CriteriaQuery();
    //   criteriaQuery.addQueryparam('accountNumber', accountNumber);
    //   criteriaQuery.addQueryparam('fromDate',"");
    //   criteriaQuery.addQueryparam('toDate',"");
    //   this.setCriteriaQuery(criteriaQuery);
    //  this.refreshGrid(criteriaQuery);
    // const criteriaQuery = new CriteriaQuery();
    // this.refreshGrid(criteriaQuery);

    let data = this.data;
    console.log('data',data.screenData.data.accountNumber)
    this.initialCriteria.addQueryparam('accountNumber',data.screenData.data.accountNumber)
    this._processShellService.setFooterVisible(false);

  }

  public doPostInit(): void {
        // const criteriaQuery = new CriteriaQuery();


        // criteriaQuery.addQueryparam("fromDate", "2022-4-01");
        // criteriaQuery.addQueryparam("toDate", "2022-5-30");
        // criteriaQuery.addQueryparam("accountNumber","510053501000");

        // this.refreshGrid(criteriaQuery);
  }

  public getGridColumnWidth(): number[] {
    return [14, 8, 52, 18, 40, 40, 40, 40, 40, 40];
  }

  override getToolBar(): ToolBar[] {
    let toolBar: ToolBar[] = [];

    toolBar.push({ type: "icon", key: "add", name: "add", hoverText: "Add " });
    toolBar.push({
      type: "icon",
      key: "edit",
      name: "modify",
      hoverText: "Modify ",
    });
    toolBar.push({
      type: "icon",
      key: "refresh",
      name: "refresh",
      hoverText: "Refresh",
    });

    return toolBar;
  }

  public override getSortSearch(): Map<
    string,
    "sort" | "search" | "sort&search" | undefined
  > {
    let _isSortSearch: Map<
      string,
      "sort" | "search" | "sort&search" | undefined
    > = new Map();
    // _isSortSearch.set('transactionDate',"sort&search");
    // _isSortSearch.set('valuedate',"sort&search");
    // _isSortSearch.set('transactionRemarks',"sort&search");
    // _isSortSearch.set('transactionAmount',"sort&search");
    // _isSortSearch.set('transactionReference',"sort&search");
    // _isSortSearch.set('dbcrFlag',"sort&search");
    // _isSortSearch.set('transactionDescription',"sort&search");
    // _isSortSearch.set('merchantId',"sort&search");
    // _isSortSearch.set('transactionCat',"sort&search");
    // _isSortSearch.set('transactionCurrency',"sort&search");
    return _isSortSearch;
  }

  private unpostedTransactiondtlsDisplayGridView: BaseFpxRoGridHandleAction = (
    name: string,
    data: Unpostedtransaction
  ) => {
    // console.log('===>',data);
  

    //WRITE YOUR CODE HERE
  };
  private unpostedTransactiondtlsDisplayGridModify: BaseFpxRoGridHandleAction = (
    name: string,
    data: any
  ) => {
    //WRITE YOUR CODE HERE
  };
  private unpostedTransactiondtlsDisplayGridEntry: BaseFpxRoGridHandleAction = (
    name: string,
    data: any
  ) => {
    //WRITE YOUR CODE HERE
  };

  public override getTransformMap(): Map<string, GridTransformFn<any>> {
    let transformMap: Map<string, GridTransformFn<any>> = new Map();
    return transformMap;
  }

  public override getGridWidth(): number {
    return 100;
  }
}
